<div [ngClass]="unifiedLicense? 'border': 'thick' " class="ui segment " fxLayout="row" fxLayoutAlign="space-between center" id="section" >
            <div fxFlex>
                {{faq?.question}}
            </div>
            <div>
                <button class="ui gray circular tiny  icon button" (click)="unifiedLicense = !unifiedLicense">
                    <i  [ngClass]="unifiedLicense?'plus icon':'times icon' "></i>
                </button>
            </div>
        </div>

        <div  [suiCollapse]="unifiedLicense" >
           <div appPadding="20px">
        <div [innerHtml]="faq?.answer"></div>
           </div>

        </div>